import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState } from '@/store'
import Template from '@/models/Template'
import TemplateService from '@/services/TemplateService'
const templateService = new TemplateService()

const defaultTemplates = {
  'apif': {
    'name': 'Apif - Template Definition',
    'id': 'apif_test',
    'fullPath': 'templates/pif/apif.docx',
    'default': true,
  },
  'apif_default': {
    'name': 'Apif - Default Safety Report',
    'id': 'apif_default',
    'fullPath': 'templates/pif/apif_default.docx',
    'default': true,
  }
}

export interface TemplateState {
  templates: Array<Template>;
}

const state: TemplateState = {
  templates: [],
}

const mutations: MutationTree<TemplateState> = {
  ADD_TEMPLATE(state: any, data: Template) {
    const index = state.templates.findIndex((obj: Template) => obj.id === data.id)
    if (index < 0) {
      state.templates.push(data)
    }
  },
  UPDATE_TEMPLATE(state: any, data: Template) {
    const index = state.templates.findIndex((obj: Template) => obj.id === data.id)
    if (index > -1) {
      Vue.set(state.templates, index, data)
    }
  },
  REMOVE_TEMPLATE(state: any, data: Template) {
    const index = state.templates.findIndex((obj: Template) => obj.id === data.id)
    if (index > -1) {
      Vue.delete(state.templates, index)
    }
  },
  RESET_STATE(state: any) {
    state.products = []
  }
}

const actions: ActionTree<TemplateState, any> = {
  clearProducts({ commit }) {
    commit('RESET_STATE')
  },
  async fetchTemplates({ commit }, projectId: string) {
    await templateService.fetchTemplates(projectId)
      .then(items => {
        if (items) {
          items.forEach((item) => {
            commit('ADD_TEMPLATE', item)
          })
        }
      })
  },
  async createTemplate({ commit }, item: Template) {
    await templateService.createTemplate(item)
      .then(result => {
        item.id = result.id
        commit('ADD_TEMPLATE', item)
      })
  },
  async editTemplate({ commit }, item: Template) {
    await templateService.editTemplate(item)
      .then(() => {
        commit('UPDATE_TEMPLATE', item)
      })
  },
  async deleteTemplate({ commit }, item: Template) {
    await templateService.deleteTemplate(item)
      .then(() => {
        commit('REMOVE_TEMPLATE', item)
      })
  },

  async deleteMultipleItems({ dispatch }, data: Array<Template>) {
    try {
      for await (const item of data) {
        dispatch('deleteTemplate', item)
      }
    }
    catch (error) {
      console.error('Error in deleteMultipleItems: ' + error)
      return false
    }
  },
  async clearTemplates({ commit, state }, projectId: string) {
    state.templates.forEach((item) => {
      commit('REMOVE_TEMPLATE', item)
    })
  },
}

const getters: GetterTree<TemplateState, RootState> = {
  getTemplates: (state: any) => {
    const arr = JSON.parse(JSON.stringify(state.templates));
    arr.unshift(defaultTemplates.apif)
    arr.unshift(defaultTemplates.apif_default)
    return arr
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
